<template>
  <PortalPageShell
    :title="pageTitle"
    :subtitle="$t('portal.airlineManager')"
  >
  <div class="portal-form-card edit-airline-page form-group">
    <div class="form-section my-2">
      <div class="loader" v-if="loading"></div>
      <input
        class="form-control mb-3"
        type="text"
        id="name"
        :placeholder="'Name'"
        v-model="airline.name"
      />
      <input
        class="form-control mb-3"
        type="text"
        id="code"
        :placeholder="'Code'"
        v-model="airline.code"
      />
      <input
        class="form-control"
        type="text"
        id="codetype"
        :placeholder="'Code Type'"
        v-model="airline.code_type"
      /><br />
      <div v-if="this.$router.currentRoute.name == 'edit-airline'" class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          id="customSwitches"
          v-model="airline.is_active"
        />
        <label class="custom-control-label" for="customSwitches"
          >Is Active?</label
        >
      </div>
      <!-- Current Logo Display Section -->
      <div v-if="this.$router.currentRoute.name == 'edit-airline'" class="mt-3">
        <label class="d-block mb-3 section-label">Airline Logos</label>
        
        <div class="logos-container" style="height: 422px; overflow-y: scroll;">
          <div class="logos-group">
            <div class="logos-group-title">FIDS Logo</div>
            <div class="logos-row logos-row-fids">
              <!-- Current Logo -->
              <div class="logo-card">
            <div class="logo-card-header">
              <span class="logo-icon mdi mdi-image"></span>
              <h6 class="logo-title">Current Logo</h6>
            </div>
            <div class="logo-card-body" @click="openLogoModal('Current Logo', airline.logo_dark_large, 'current', 'logo_dark_large')">
              <!-- Always render preview wrapper so default logo can be shown even when filename is missing -->
              <div class="logo-preview-wrapper">
                <img
                  :key="(airline.logo_dark_large || 'current') + '-' + logoCacheBust"
                  :src="logoUrl(airline.logo_dark_large) + (logoCacheBust ? ('?t=' + logoCacheBust) : '')"
                  :alt="airline.name + ' current logo'"
                  class="airline-logo-preview"
                  @error="onCurrentLogoError"
                  @load="onCurrentLogoLoad"
                />
                <div class="logo-actions">
                  <button
                    class="btn-icon btn-download"
                    title="Download current logo"
                    v-if="airline.logo_dark_large"
                    @click.stop="downloadCurrentLogo(airline.id, airline.logo_dark_large, 'current')"
                  >
                    <span class="mdi mdi-download"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>

              <!-- Default Logo -->
              <div class="logo-card">
            <div class="logo-card-header">
              <span class="logo-icon mdi mdi-image-filter-none"></span>
              <h6 class="logo-title">Default Logo</h6>
            </div>
            <div class="logo-card-body" @click="openLogoModal('Default Logo', airline.logo_dark_small, 'default', 'logo_dark_small')">
              <div class="logo-preview-wrapper">
                <img
                  :key="(airline.logo_dark_small || 'default') + '-' + logoCacheBust"
                  :src="logoUrl(airline.logo_dark_small) + (logoCacheBust ? ('?t=' + logoCacheBust) : '')"
                  :alt="airline.name + ' default logo'"
                  class="airline-logo-preview"
                  @error="onDefaultLogoError"
                />
                <div class="logo-actions">
                  <button
                    class="btn-icon btn-download"
                    title="Download default logo"
                    v-if="airline.logo_dark_small"
                    @click.prevent="downloadCurrentLogo(airline.id, airline.logo_dark_small, 'default')"
                  >
                    <span class="mdi mdi-download"></span>
                  </button>
                </div>
              </div>
              <div v-if="!airline.logo_dark_small" class="logo-placeholder">
                <span class="mdi mdi-image-off"></span>
                <span>No Logo</span>
              </div>
            </div>
              </div>
            </div>
          </div>

          <div class="logos-group">
            <div class="logos-group-title">Checkin -Images</div>
            <div class="logos-row">

              <!-- Check-in Logo -->
              <div class="logo-card">
            <div class="logo-card-header">
              <span class="logo-icon mdi mdi-check-circle"></span>
              <h6 class="logo-title">Check-in Logo</h6>
            </div>
            <div class="logo-card-body" @click="openLogoModal('Check-in Logo', airline.logo_checkin, 'checkin', 'logo_checkin')">
              <div class="logo-preview-wrapper">
                <img
                  :key="(airline.logo_checkin || 'checkin') + '-' + logoCacheBust"
                  :src="logoUrl(airline.logo_checkin) + (logoCacheBust ? ('?t=' + logoCacheBust) : '')"
                  :alt="airline.name + ' check-in logo'"
                  class="airline-logo-preview"
                  @error="onCheckInLogoError"
                />
                <div class="logo-actions">
                  <button
                    class="btn-icon btn-download"
                    title="Download check-in logo"
                    v-if="airline.logo_checkin"
                    @click.stop="downloadCurrentLogo(airline.id, airline.logo_checkin, 'checkin')"
                  >
                    <span class="mdi mdi-download"></span>
                  </button>
                </div>
              </div>
              <div v-if="!airline.logo_checkin" class="logo-placeholder">
                <span class="mdi mdi-image-off"></span>
                <span>No Logo</span>
              </div>
            </div>
              </div>

              <!-- Check-in Economy Logo -->
              <div class="logo-card">
            <div class="logo-card-header">
              <span class="logo-icon mdi mdi-seat-passenger"></span>
              <h6 class="logo-title">Check-in Economy</h6>
            </div>
            <div class="logo-card-body" @click="openLogoModal('Check-in Economy', airline.logo_checkin_economy, 'checkin-economy', 'logo_checkin_economy')">
              <div class="logo-preview-wrapper">
                <img
                  :key="(airline.logo_checkin_economy || 'checkin-economy') + '-' + logoCacheBust"
                  :src="logoUrl(airline.logo_checkin_economy) + (logoCacheBust ? ('?t=' + logoCacheBust) : '')"
                  :alt="airline.name + ' check-in economy logo'"
                  class="airline-logo-preview"
                  @error="onCheckInEconomyError"
                />
                <div class="logo-actions">
                  <button
                    class="btn-icon btn-download"
                    title="Download check-in economy logo"
                    v-if="airline.logo_checkin_economy"
                    @click.stop="downloadCurrentLogo(airline.id, airline.logo_checkin_economy, 'checkin-economy')"
                  >
                    <span class="mdi mdi-download"></span>
                  </button>
                </div>
              </div>
              <div v-if="!airline.logo_checkin_economy" class="logo-placeholder">
                <span class="mdi mdi-image-off"></span>
                <span>No Logo</span>
              </div>
            </div>
              </div>

              <!-- Check-in Premium Logo -->
              <div class="logo-card">
            <div class="logo-card-header">
              <span class="logo-icon mdi mdi-star"></span>
              <h6 class="logo-title">Check-in Premium</h6>
            </div>
            <div class="logo-card-body" @click="openLogoModal('Check-in Premium', airline.logo_checkin_premium, 'checkin-premium', 'logo_checkin_premium')">
              <div class="logo-preview-wrapper">
                <img
                  :key="(airline.logo_checkin_premium || 'checkin-premium') + '-' + logoCacheBust"
                  :src="logoUrl(airline.logo_checkin_premium) + (logoCacheBust ? ('?t=' + logoCacheBust) : '')"
                  :alt="airline.name + ' check-in premium logo'"
                  class="airline-logo-preview"
                  @error="onCheckInPremiumError"
                />
                <div class="logo-actions">
                  <button
                    class="btn-icon btn-download"
                    title="Download check-in premium logo"
                    v-if="airline.logo_checkin_premium"
                    @click.stop="downloadCurrentLogo(airline.id, airline.logo_checkin_premium, 'checkin-premium')"
                  >
                    <span class="mdi mdi-download"></span>
                  </button>
                </div>
              </div>
              <div v-if="!airline.logo_checkin_premium" class="logo-placeholder">
                <span class="mdi mdi-image-off"></span>
                <span>No Logo</span>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="this.$router.currentRoute.name == 'edit-airline'" class="mt-2">
        <label class="d-block mb-1 section-label">Logo Management</label>
        <p class="form-text text-muted mb-2 small">
          Click on any logo above to manage preview, download, or replace options.
        </p>
      </div>
      <div v-if="this.$router.currentRoute.name == 'new-airline'" class="mt-2">
        <label class="d-block mb-1 section-label">Upload Logo (optional)</label>
        <input
          ref="logoInput"
          type="file"
          accept="image/*"
          class="d-none"
          @change="onLogoFileChange"
        />
        <button
          class="btn btn-outline-secondary btn-sm mt-1"
          :disabled="uploadingLogo"
          @click="triggerChooseLogo"
        >
          Choose Logo
        </button>
        <span v-if="selectedLogoFile" class="ml-2 small text-muted">{{ selectedLogoFile.name }}</span>
        <div v-if="selectedLogoPreviewUrl" class="mt-2">
          <img :src="selectedLogoPreviewUrl" alt="Selected logo preview" class="airline-logo-preview" />
        </div>
      </div>
    </div>
    
    <!-- Logo Management Modal -->
    <div v-if="logoModal.show" class="logo-modal-overlay" @click="closeLogoModal">
      <div class="logo-modal" @click.stop>
        <div class="logo-modal-header">
          <h5 class="logo-modal-title">{{ logoModal.title }}</h5>
          <button class="btn-close" @click="closeLogoModal">
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="logo-modal-body">
          <!-- Large Preview -->
          <div class="logo-preview-section">
            <h6>Preview</h6>
            <div class="logo-large-preview">
              <img 
                v-if="logoModal.logoUrl && logoModal.logoUrl.trim()"
                :src="logoUrl(logoModal.logoUrl) + (logoCacheBust ? ('?t=' + logoCacheBust) : '')"
                :alt="logoModal.title + ' preview'"
                @error="onModalLogoError"
                @load="onModalLogoLoad"
              />
              <div v-else class="logo-large-placeholder">
                <span class="mdi mdi-image-off"></span>
                <span>No Logo Available</span>
              </div>
            </div>
          </div>
          
          <!-- Actions -->
          <div class="logo-actions-section">
            <h6>Actions</h6>
            <div class="action-buttons">
              <button 
                v-if="logoModal.logoUrl"
                class="btn btn-success btn-action"
                @click="downloadModalLogo"
              >
                <span class="mdi mdi-download"></span>
                Download
              </button>
              
              <button 
                class="btn btn-info btn-action"
                @click="copyFromDefaultLogo"
                v-if="logoModal.logoField !== 'logo_dark_small'"
              >
                <span class="mdi mdi-content-copy"></span>
                Copy from Default
              </button>
              
              <button 
                class="btn btn-primary btn-action"
                @click="triggerLogoReplace"
              >
                <span class="mdi mdi-upload"></span>
                Replace Logo
              </button>
            </div>
          </div>
          
          <!-- Upload Section (shown when replace is clicked) -->
          <div v-if="logoModal.showUpload" class="logo-upload-section">
            <h6>Upload New Logo</h6>
            <p class="upload-info">
              Recommended: upload a logo around <strong>{{ logoUploadRecommendation }}</strong> (PNG) with transparent background.
            </p>
            <input
              ref="modalLogoInput"
              type="file"
              accept="image/*"
              class="d-none"
              @change="onModalLogoFileChange"
            />
            <div class="upload-controls">
              <button 
                class="btn btn-outline-secondary"
                @click="triggerModalFileInput"
                :disabled="uploadingLogo"
              >
                {{ uploadingLogo ? 'Uploading...' : 'Choose File' }}
              </button>
              <span v-if="modalSelectedFile" class="file-name">{{ modalSelectedFile.name }}</span>
            </div>
            
            <!-- Preview of selected file -->
            <div v-if="modalPreviewUrl" class="modal-new-preview">
              <h6>New Logo Preview</h6>
              <img :src="modalPreviewUrl" alt="New logo preview" />
            </div>
            
            <div v-if="modalSelectedFile" class="upload-actions">
              <button 
                class="btn btn-success"
                @click="uploadModalLogo"
                :disabled="uploadingLogo"
              >
                <span class="mdi mdi-check"></span>
                Upload Logo
              </button>
              <button 
                class="btn btn-secondary"
                @click="cancelModalUpload"
                :disabled="uploadingLogo"
              >
                <span class="mdi mdi-close"></span>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Notification Toast -->
    <div v-if="notification.show" :class="['notification-toast', notification.type]">
      <div class="notification-content">
        <span class="notification-icon" :class="getNotificationIcon()"></span>
        <span class="notification-message">{{ notification.message }}</span>
        <button class="notification-close" @click="notification.show = false">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    
    <div class="action-bar">
      <div class="spacer"></div>
      <button v-if="this.$router.currentRoute.name == 'new-airline'" class="btn btn-success" @click="addAirline">Add Airline</button>
      <button v-if="this.$router.currentRoute.name == 'edit-airline'" class="btn btn-primary" @click="updateAirline($route.params.id)">Update Airline</button>
    </div>
  </div>
  </PortalPageShell>
</template>
<script>
import PortalPageShell from '../layout/PortalPageShell.vue';
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
import defaultLogo from '../../assets/default_logo.png';
export default {
  name: 'Airline',
  components: {
    PortalPageShell,
  },
  data: function () {
    return {
      loading: false,
      airlineData: '',
      switchValue: false,
      airline: {
        name: '',
        code: '',
        code_type: '',
        is_active: true,
        id: '',
        logo_dark_large: '',
        logo_dark_small: '',
        logo_light_large: '',
        logo_checkin: '',
        logo_checkin_economy: '',
        logo_checkin_premium: ''
      },
      nameCheck: '',
      codeCheck: '',
      selectedLogoFile: null,
      selectedLogoPreviewUrl: '',
      uploadingLogo: false,
      logoCacheBust: 0,
      currentLogoAvailable: true,
      defaultLogo,
      // Modal state
      logoModal: {
        show: false,
        title: '',
        logoUrl: '',
        logoType: '',
        logoField: '',
        showUpload: false
      },
      modalSelectedFile: null,
      modalPreviewUrl: '',
      // Notification state
      notification: {
        show: false,
        message: '',
        type: 'success'
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to && to.name === 'edit-airline') {
        vm.handleEditRoute(to);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to && to.name === 'edit-airline') {
      this.handleEditRoute(to);
    }
    next();
  },
  mounted() {
    if (this.$router.currentRoute.name == 'edit-airline') {
      this.handleEditRoute(this.$route);
    }
  },
  activated() {
    if (this.$router.currentRoute.name == 'edit-airline') {
      this.handleEditRoute(this.$route);
    }
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
    pageTitle() {
      return this.$router.currentRoute.name === 'new-airline'
        ? 'Add Airline'
        : 'Edit Airline';
    },
    defaultLogoName(){
      const slug = this.slugifyName(this.airline.name || 'airline');
      // If a file is selected (new-airline flow), derive extension from it; else default to png
      let ext = 'png';
      if (this.selectedLogoFile && this.selectedLogoFile.name) {
        const m = this.selectedLogoFile.name.match(/\.([a-zA-Z0-9]+)$/);
        if (m && m[1]) {
          ext = m[1].toLowerCase();
        }
      }
      return `${slug}.${ext}`;
    },
    logoUploadRecommendation() {
      const field = (this.logoModal && this.logoModal.logoField) || '';
      const checkinFields = ['logo_checkin', 'logo_checkin_economy', 'logo_checkin_premium'];
      return checkinFields.includes(field) ? '1920x1080 px' : '334x122 px';
    }
  },
  watch: {
    '$route.params.code'(newVal) {
      // When navigating between airlines or returning from ManageAirline,
      // ensure we always reload the latest airline details
      if (this.$router.currentRoute.name === 'edit-airline' && newVal) {
        this.reloadAirlineDetails();
      }
    },
    '$route.params.code_type'(newVal) {
      if (this.$router.currentRoute.name === 'edit-airline' && newVal) {
        this.reloadAirlineDetails();
      }
    }
  },
  methods: {
    async handleEditRoute(route) {
      const params = (route && route.params) || {};
      const code_type = params.code_type;
      const code = params.code;

      if (code_type) this.airline.code_type = code_type;
      if (code) this.airline.code = code;

      if (params.id) this.airline.id = params.id;
      if (params.name) this.airline.name = params.name;
      if (typeof params.is_active !== 'undefined') this.airline.is_active = params.is_active;

      if (params.logo_dark_large) this.airline.logo_dark_large = params.logo_dark_large;
      if (params.logo_dark_small) this.airline.logo_dark_small = params.logo_dark_small;
      if (params.logo_light_large) this.airline.logo_light_large = params.logo_light_large;
      if (params.logo_light_small) this.airline.logo_light_small = params.logo_light_small;
      if (params.logo_checkin) this.airline.logo_checkin = params.logo_checkin;

      this.nameCheck = this.airline.name || this.nameCheck;
      this.codeCheck = this.airline.code || this.codeCheck;

      await this.reloadAirlineDetails();
      this.logoCacheBust = Date.now();
    },
    async reloadAirlineDetails(){
      // Re-fetch airline details so all logo fields reflect latest backend state
      const code_type = this.airline.code_type || (this.$route.params && this.$route.params.code_type);
      const code = this.airline.code || (this.$route.params && this.$route.params.code);
      if (!code_type || !code) {
        return;
      }
      try {
        this.loading = true;
        const resp = await axios.get(this.$hostName + '/airlines/details');
        const list = (resp && resp.data) || [];
        const found = list.find(
          (a) => a && a.code_type == code_type && a.code == code
        );
        if (found) {
          this.airline = {
            name: found.name || '',
            code: found.code || '',
            code_type: found.code_type || '',
            is_active: found.is_active,
            id: found.id,
            logo_dark_large: found.logo_dark_large || '',
            logo_dark_small: found.logo_dark_small || '',
            logo_light_large: found.logo_light_large || '',
            logo_checkin: found.logo_checkin || '',
            logo_checkin_economy: found.logo_checkin_economy || '',
            logo_checkin_premium: found.logo_checkin_premium || ''
          };
          this.nameCheck = found.name || '';
          this.codeCheck = found.code || '';
          this.logoCacheBust = Date.now();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async downloadCurrentLogo(id, logoDarkLarge, logoType = 'current'){
      try{
        const url = `${this.$hostName}/airlines/${id}/logo/download`;
        const ts = this.logoCacheBust || Date.now();
        const resp = await axios.get(url, { params: { file: logoDarkLarge, t: ts }, responseType: 'blob' });
        const blobUrl = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        const fileName = logoDarkLarge || (this.airline.name ? `${this.airline.name}-${logoType}.png` : `airline-${logoType}-logo.png`);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      } catch (e) {
        console.error(e);
        window.open(this.logoUrl(logoDarkLarge), '_blank');
      }
    },
    onCurrentLogoError(e){
      // For current logo, fall back to the shared default logo image
      // so user still sees a preview and can choose to replace it.
      if (e && e.target) {
        e.target.onerror = null; // prevent infinite loop
        e.target.src = this.defaultLogo;
      }
      this.currentLogoAvailable = false;
    },
    onCurrentLogoLoad(){
      this.currentLogoAvailable = true;
    },
    onDefaultLogoError(e){
      if (e && e.target) {
        e.target.onerror = null;
        e.target.src = this.defaultLogo;
      }
    },
    onCheckInLogoError(e){
      // For check-in logo, also fall back to the shared default logo image
      // so it behaves like Economy and Premium logos when file is missing.
      if (e && e.target) {
        e.target.onerror = null;
        e.target.src = this.defaultLogo;
      }
    },
    onOperationalLogoError(e){
      if (e && e.target) {
        e.target.onerror = null;
        e.target.src = this.defaultLogo;
      }
    },
    onCheckInEconomyError(e){
      if (e && e.target) {
        e.target.onerror = null;
        e.target.src = this.defaultLogo;
      }
    },
    onCheckInPremiumError(e){
      if (e && e.target) {
        e.target.onerror = null;
        e.target.src = this.defaultLogo;
      }
    },
    async copyFromDefaultLogo() {
      // Copy default logo (logo_dark_small) to any other logo type
      if (!this.airline.logo_dark_small) {
        this.showNotification('No default logo available to copy', 'error');
        return;
      }

      try {
        const url = `${this.$hostName}/airlines/${this.airline.id}/logo/copy`;
        const payload = {
          fromField: 'logo_dark_small',
          toField: this.logoModal.logoField
        };
        const resp = await axios.post(url, payload);

        if (resp && resp.status === 200 && resp.data && resp.data.success) {
          const toField = resp.data.toField || this.logoModal.logoField;
          const fileName = resp.data.fileName || this.airline.logo_dark_small;

          // Update local state with copied filename
          this.airline[toField] = fileName;
          this.logoModal.logoUrl = fileName;

          // Show success notification at top
          this.showNotification('Default logo copied to ' + this.logoModal.title, 'success');

          // Update cache bust to refresh display
          this.logoCacheBust = Date.now();
          // Ensure all logo fields reflect latest state from backend
          this.reloadAirlineDetails();
        } else {
          this.showNotification('Failed to copy default logo', 'error');
        }
      } catch (err) {
        console.error(err);
        this.showNotification('Failed to copy default logo', 'error');
      }
    },
    // Modal methods
    openLogoModal(title, logoUrl, logoType, logoField) {
      this.logoModal = {
        show: true,
        title: title,
        logoUrl: logoUrl,
        logoType: logoType,
        logoField: logoField,
        showUpload: false
      };
      this.modalSelectedFile = null;
      this.modalPreviewUrl = '';
    },
    closeLogoModal() {
      this.logoModal.show = false;
      this.modalSelectedFile = null;
      this.modalPreviewUrl = '';
    },
    downloadModalLogo() {
      if (this.logoModal.logoUrl) {
        this.downloadCurrentLogo(this.airline.id, this.logoModal.logoUrl, this.logoModal.logoType);
      }
    },
    triggerLogoReplace() {
      this.logoModal.showUpload = true;
    },
    triggerModalFileInput() {
      if (this.$refs && this.$refs.modalLogoInput) {
        this.$refs.modalLogoInput.click();
      }
    },
    onModalLogoFileChange(e) {
      const file = e && e.target && e.target.files && e.target.files[0] ? e.target.files[0] : null;
      this.modalSelectedFile = file;
      
      // Clear previous preview
      if (this.modalPreviewUrl) {
        if (window && window.URL && typeof window.URL.revokeObjectURL === 'function') {
          window.URL.revokeObjectURL(this.modalPreviewUrl);
        }
        this.modalPreviewUrl = '';
      }
      
      if (file) {
        try { 
          this.modalPreviewUrl = window.URL.createObjectURL(file); 
        } catch(_) { 
          this.modalPreviewUrl = ''; 
        }
      }
    },
    async uploadModalLogo() {
      if(!this.modalSelectedFile){
        this.$alert('Please choose a logo file to upload');
        return;
      }
      
      try{
        this.uploadingLogo = true;
        const formData = new FormData();
        
        // Determine target filename: existing or slugified airline name + original extension
        let targetName = this.airline[this.logoModal.logoField];
        if(!targetName){
          const slug = this.slugifyName(this.airline.name);
          const original = this.modalSelectedFile.name || '';
          const match = original.match(/\.([a-zA-Z0-9]+)$/);
          const ext = match ? match[1] : 'png';
          // Include logoField in the filename so each logo type has its own file
          // (e.g. airline-logo_dark_small.png, airline-logo_checkin_economy.png)
          targetName = `${slug}-${this.logoModal.logoField}.${ext}`;
        }
        
        formData.append('logo', this.modalSelectedFile, targetName);
        formData.append('existing', this.airline[this.logoModal.logoField] || '');
        formData.append('logoField', this.logoModal.logoField); // Send which field to update
        
        const url = `${this.$hostName}/airlines/${this.airline.id}/logo`;
        const response = await axios.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        
        if(response && (response.status === 200 || response.status === 204)){
          // Close modal first so the success alert appears on top
          this.closeLogoModal();
          this.$alert('Logo uploaded successfully');
          
          // Update the specific logo field in the airline data
          this.airline[this.logoModal.logoField] = targetName;
          
          // Force preview refresh
          this.logoCacheBust = Date.now();
          
          // Update modal with new logo
          this.logoModal.logoUrl = targetName;
          
          // Reset modal state
          this.modalSelectedFile = null;
          this.modalPreviewUrl = '';
          this.logoModal.showUpload = false;
          // Ensure all logo fields reflect latest state from backend
          this.reloadAirlineDetails();
          
        } else {
          this.$alert('Upload completed, but response was unexpected');
        }
      } catch(err){
        console.error(err);
        this.$alert('Failed to upload logo');
      } finally {
        this.uploadingLogo = false;
      }
    },
    cancelModalUpload() {
      this.modalSelectedFile = null;
      this.modalPreviewUrl = '';
      this.logoModal.showUpload = false;
    },
    onModalLogoError(e) {
      if (e && e.target) {
        e.target.onerror = null;
        e.target.src = this.defaultLogo;
      }
    },
    onModalLogoLoad(e) {
      console.log('Modal logo loaded successfully:', e.target.src);
    },
    showNotification(message, type = 'success') {
      this.notification.message = message;
      this.notification.type = type;
      this.notification.show = true;
      
      // Auto hide after 3 seconds
      setTimeout(() => {
        this.notification.show = false;
      }, 3000);
    },
    logoUrl(fileName){
      const base = process.env.VUE_APP_AIRLINE_IMAGES_BASE || process.env.VUE_APP_IMAGES_BASE || '';
      let url = fileName;
      if (base) {
        const trimmed = base.replace(/\/$/, '');
        url = `${trimmed}/${fileName}`;
      }
      console.log('Logo URL constructed:', url, 'for fileName:', fileName);
      return url;
    },
    getNotificationIcon() {
      return this.notification.type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle';
    },
    slugifyName(name){
      if(!name) return 'airline';
      return name
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
    },
    triggerChooseLogo(){
      if (this.$refs && this.$refs.logoInput) {
        this.$refs.logoInput.click();
      }
    },
    onLogoChosenAndUpload(e, id, existingFileName){
      const file = e && e.target && e.target.files && e.target.files[0] ? e.target.files[0] : null;
      this.selectedLogoFile = file;
      if (file) {
        this.uploadLogo(id, existingFileName);
      }
    },
    onLogoFileChange(e){
      const file = e && e.target && e.target.files && e.target.files[0] ? e.target.files[0] : null;
      this.selectedLogoFile = file;
      // update preview for new-airline flow
      if (this.selectedLogoPreviewUrl) {
        if (window && window.URL && typeof window.URL.revokeObjectURL === 'function') {
          window.URL.revokeObjectURL(this.selectedLogoPreviewUrl);
        }
        this.selectedLogoPreviewUrl = '';
      }
      if (file) {
        try { this.selectedLogoPreviewUrl = window.URL.createObjectURL(file); } catch(_) { this.selectedLogoPreviewUrl = ''; }
      }
    },
    async uploadLogo(id, existingFileName){
      if(!this.selectedLogoFile){
        this.$alert('Please choose a logo file to upload');
        return;
      }
      try{
        this.uploadingLogo = true;
        const formData = new FormData();
        // Determine target filename: existing or slugified airline name + original extension (or .png)
        let targetName = existingFileName;
        if(!targetName){
          const slug = this.slugifyName(this.airline.name);
          const original = this.selectedLogoFile.name || '';
          const match = original.match(/\.([a-zA-Z0-9]+)$/);
          const ext = match ? match[1] : 'png';
          targetName = `${slug}.${ext}`;
        }
        formData.append('logo', this.selectedLogoFile, targetName);
        formData.append('existing', existingFileName || '');
        formData.append('logoField', 'logo_dark_large');
        const url = `${this.$hostName}/airlines/${id}/logo`;
        const response = await axios.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if(response && (response.status === 200 || response.status === 204)){
          this.$alert('Logo uploaded successfully');
          // force preview refresh
          this.logoCacheBust = Date.now();
          // update local state if backend returned a new name
          if(response.data && response.data.logo_dark_large){
            this.airline.logo_dark_large = response.data.logo_dark_large;
          } else {
            this.airline.logo_dark_large = targetName;
          }
        } else {
          this.$alert('Upload completed, but response was unexpected');
        }
      } catch(err){
        console.error(err);
        this.$alert('Failed to upload logo');
      } finally {
        this.uploadingLogo = false;
      }
    },
    async addAirline() {
      if (this.airline.name == '') {
        this.$alert('Enter Airline Name');
      } else if (this.airline.code == '') {
        this.$alert('Enter Airline Code');
      } else if (this.airline.code_type == '') {
        this.$alert('Enter Airline Code Type');
      }
       else {
        try{
          this.loading = true;
          // Back end expects name without spaces
          this.airline.name = this.airline.name.split(' ').join('');
          // Include default logo filenames if backend supports them
          const payload = {
            airline: {
              ...this.airline,
              logo_dark_large: this.defaultLogoName,
              logo_dark_small: this.defaultLogoName,
              logo_light_large: this.defaultLogoName,
              logo_light_small: this.defaultLogoName,
            }
          };
          const createResp = await axios.post(this.$hostName + '/airlines/store', payload);
          if (createResp.status == 202) {
            this.loading = false;
            this.$alert('Airline already exists');
            return;
          } else if (createResp.status == 203) {
            this.loading = false;
            this.$alert('Airline code already exists');
            return;
          }
          // Try to upload logo if user selected a file
          const newId = (createResp.data && (createResp.data.id || createResp.data.airline_id)) || null;
          if (newId && this.selectedLogoFile) {
            // Compute target name from airline name and file ext
            const slug = this.slugifyName(this.airline.name);
            const original = this.selectedLogoFile.name || '';
            const match = original.match(/\.([a-zA-Z0-9]+)$/);
            const ext = match ? match[1] : 'png';
            const targetName = `${slug}.${ext}`;
            await this.uploadLogo(newId, targetName);
          }
          this.loading = false;
          this.$router.push({ name: routeNames.manageAirline });
        } catch (error){
          console.log(error);
          this.loading = false;
        }
      }
    },
    updateAirline(id) {
      if (this.airline.name == '') {
        this.$alert('Enter Airline Name');
      } else if (this.airline.code == '') {
        this.$alert('Enter Airline Code');
      } else if (this.airline.code_type == '') {
        this.$alert('Enter Airline Code Type');
      } else {
        this.airline.name = this.airline.name.split(' ').join('');
        this.loading = true;
        axios
          .put(this.$hostName + '/airlines/' + id, {
            airline: this.airline,
            nameCheck: this.nameCheck,
            codeCheck: this.codeCheck,
          })
          .then((response) => {
            if (response.status == 202) {
              this.loading = false;
              this.$alert('Airline already exists');
            } else if (response.status == 203) {
              this.loading = false;
              this.$alert('Airline code already exists');
            } else {
              this.loading = false;
              this.$router.push({ name: routeNames.manageAirline });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
  },
};
</script>
<style scoped>
.loader {
  /* Loader Div Class */
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  background-image: url('../../assets/loading.gif');
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.edit-airline-page{
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 40px);
}
.form-section{
  flex: 1 1 auto;
  overflow: auto;
}

.logos-container {
  overflow-y: scroll;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: rgba(120, 120, 120, 0.9) rgba(0, 0, 0, 0.08);
}

.logos-container::-webkit-scrollbar {
  width: 10px;
}

.logos-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.06);
}

.logos-container::-webkit-scrollbar-thumb {
  background-color: rgba(120, 120, 120, 0.9);
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 0.06);
}

@media (max-width: 1439px) {
  .edit-airline-page {
    max-height: calc(100vh - 40px);
    overflow: hidden;
  }
  .form-section {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 80px;
  }




  .logos-container {
    gap: 12px;
    padding: 4px 0;
    overflow-y: scroll !important;
    height: 422px;
  }
  .logos-row {
    gap: 10px;
  }
  .logo-card {
    min-width: 150px;
    max-width: 150px;
    border-radius: 10px;
  }
  .logo-card-header {
    padding: 8px 10px 4px;
  }
  .logo-card-body {
    padding: 8px 10px;
  }
  .airline-logo-preview {
    height: 60px;
    padding: 4px;
  }
  .logo-placeholder {
    height: 60px;
  }

  .edit-airline-page .form-control {
    margin-bottom: 10px !important;
  }
}

/* Scroll and compact layout when screen is smaller than 1440px */
@media (max-width: 1200px) {
  .edit-airline-page {
    max-height: calc(100vh - 40px);
    overflow: hidden;
  }
  .form-section {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .logos-container { gap: 10px; padding: 2px 0; }
  .logos-row { gap: 8px; }
  .logo-card { min-width: 160px; max-width: 200px; }
  .logo-card-header { padding: 8px 10px 4px; }
  .logo-card-body { padding: 8px; }
  .airline-logo-preview { height: 70px; padding: 4px; }
  .logo-placeholder { height: 70px; }
  .logo-title { font-size: 12px; }
  .logo-icon { font-size: 16px; }
}

/* Extra compact for very small screens */
@media (max-width: 992px) {
  .logos-container { gap: 8px; }
  .logo-card { min-width: 140px; max-width: 180px; }
  .airline-logo-preview { height: 60px; }
  .logo-placeholder { height: 60px; }
  .logo-card-header { padding: 6px 8px 2px; }
  .logo-card-body { padding: 6px; }
  h1.p-2 { font-size: 1rem; padding: 2px !important; }
}

/* No scroll at 1440px and above - natural flow */
@media (min-width: 1440px) {
  .edit-airline-page {
    max-height: none;
    overflow: visible;
  }
  .form-section {
    overflow-y: visible;
  }
}
.action-bar{
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #eee;
  padding: 10px 12px;
  display: flex;
  gap: 10px;
  align-items: center;
}
.action-bar .spacer{ flex: 1; }
.airline-logo-preview {
  width: 100%;
  height: 120px;
  object-fit: contain;
  border: 2px solid #e9ecef;
  background: #fff;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}



.logos-group-title {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.logos-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: stretch;
}

.logos-row-fids {
  justify-content: start;
}

/* Logo Cards */
.logo-card {
  min-width: 220px;
  max-width: 280px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.logo-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #007bff;
}

.logo-card-header {
  display: flex;
  align-items: center;
  padding: 12px 16px 8px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
}

.logo-icon {
  font-size: 18px;
  margin-right: 8px;
  opacity: 0.9;
}

.logo-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.logo-card-body {
  padding: 16px;
  position: relative;
}

.logo-preview-wrapper {
  position: relative;
  display: block;
}

.logo-preview-wrapper:hover .airline-logo-preview {
  border-color: #007bff;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
}

.logo-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.logo-preview-wrapper:hover .logo-actions {
  opacity: 1;
}

.btn-icon {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-download {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.btn-download:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.logo-placeholder {
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  color: #6c757d;
  font-size: 12px;
  transition: all 0.3s ease;
}

.logo-placeholder:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.logo-placeholder .mdi {
  font-size: 24px;
  margin-bottom: 4px;
  opacity: 0.6;
}

/* Scrollbar Styling */
.logos-container::-webkit-scrollbar {
  height: 6px;
}

.logos-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.logos-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-radius: 3px;
}

.logos-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
}

/* Modal Styles */
.logo-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(4px);
}

.logo-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.logo-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px 16px 0 0;
}

.logo-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.btn-close {
  width: 36px;
  height: 36px;
  border: none;
  background: #dc3545;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 16px;
}

.btn-close:hover {
  background: #c82333;
  transform: scale(1.1);
}

.logo-modal-body {
  padding: 24px;
}

.logo-preview-section,
.logo-actions-section,
.logo-upload-section {
  margin-bottom: 24px;
}

.logo-preview-section h6,
.logo-actions-section h6,
.logo-upload-section h6 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.logo-large-preview {
  text-align: center;
  padding: 16px;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-large-preview img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.logo-large-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #6c757d;
  font-size: 14px;
}

.logo-large-placeholder .mdi {
  font-size: 48px;
  margin-bottom: 8px;
  opacity: 0.5;
}

.action-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-action {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  justify-content: center;
}

.btn-action .mdi {
  font-size: 16px;
}

.upload-info {
  margin: 8px 0;
  font-size: 13px;
  color: #6c757d;
  line-height: 1.4;
}

.upload-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 0;
}

.file-name {
  font-size: 13px;
  color: #495057;
  font-style: italic;
}

.modal-new-preview {
  margin: 16px 0;
  text-align: center;
}

.modal-new-preview h6 {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}

.modal-new-preview img {
  max-width: 200px;
  max-height: 120px;
  object-fit: contain;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 8px;
  background: white;
}

.upload-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

/* Notification Toast Styles */
.notification-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 20000;
  min-width: 300px;
  max-width: 500px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: slideInRight 0.3s ease-out;
}

.notification-toast.success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.notification-toast.error {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.notification-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
}

.notification-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.notification-message {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.notification-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  font-size: 14px;
}

.notification-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}
</style>
